import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { handleActiveLink } from '../../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';

import '../Assets/css/dashboard.scss';
import MainContent from '../Components/MainContent';

function Dashboard(props) {
    // Set active link for dashboard
    useEffect(() => {
        // Update the active link in Redux state
        props.handleActiveLink({ activeClass: 'dashboard_module', accName: '' });
    }, []);

    return <MainContent />;
}

const mapStateToProps = (state) => {
    return {
        leftbar: state.mainReducerData.leftbar,
        activeLink: state.mainReducerData.activeLink
    };
};

export default connect(mapStateToProps, { handleActiveLink })(withNamespaces()(Dashboard));